const equipamentosEngenhariaClinica = [
  'AMALGAMADOR',
  'AUTOCLAVE',
  'BALANÇA ADULTO',
  'BALANÇA PEDIÁTRICA',
  'CÂMARA PARA VACINAS',
  'CANETA ALTA ROTAÇÃO',
  'COMPRESSOR',
  'CONSULTÓRIO ODONTOLÓGICO',
  'CONTRA ÂNGULO',
  'DERMATOSCÓPIO',
  'DESTILADORA',
  'DETECTOR FETAL',
  'ESFIGMOMANÔMETRO',
  'ESFIGMOMANÔMETRO DIGITAL',
  'ESTETOSCÓPIO',
  'FOCO CLÍNICO',
  'FOTOPOLIMERIZADOR',
  'GLICOSÍMETRO / HGT / ON CALL PLUS',
  'MESA GINECOLÓGICA',
  'MESA GINECOLÓGICA MECÂNICA',
  'MICROMOTOR',
  'MOCHO',
  'NEBULIZADOR',
  'NEGATOSCÓPIO',
  'OFTALMOSCÓPIO',
  'OTOSCÓPIO',
  'OXÍMETRO',
  'PEÇA RETA',
  'SELADORA',
  'SERINGA TRÍPLICE',
  'TERMÔMETRO DIGITAL',
  'ULTRASSOM ODONTOLÓGICO',
  'OUTROS'
];

export default equipamentosEngenhariaClinica;
